<template>
	<v-ons-page>
		<ons-toolbar>
			<div class="left"><ons-back-button></ons-back-button></div>
			<div class="center">Back to events list</div>
		</ons-toolbar>
		<div class="content">
			<div  class="qf-event-location-map">
				<transition name="qfFade">
					<google-map id="map" ref="Map1" v-if="hasCoordinates" :center="mapData.position" :options = "{disableDefaultUI:true}" :zoom="14">
						<google-map-marker :position="mapData.position"></google-map-marker>
					</google-map>
				</transition>
			</div>
			<v-ons-list-title>{{eventData.title}}</v-ons-list-title>
			<v-ons-list>
				<v-ons-list-item v-if="eventData.attachment">
					<div class="left icon"><v-ons-icon icon="fa-map-marker" class="list-item__icon"></v-ons-icon></div>
					<div class="center">{{eventData.location}}</div>
				</v-ons-list-item>
				<v-ons-list-item>
					<div class="left icon"><v-ons-icon icon="fa-calendar" class="list-item__icon"></v-ons-icon></div>
					<div class="center">{{onDate | fullDateStartTime}}</div>
				</v-ons-list-item>
				<v-ons-list-item>
					<div class="left icon"><v-ons-icon icon="fa-clock" class="list-item__icon"></v-ons-icon></div>
					<div class="center">
						<span v-if="eventData.start_time">
							{{eventData.start_time | truncatedStartTime}}
							<template v-if="eventData.end_time && eventData.end_time !== eventData.start_time"> - {{eventData.end_time | truncatedStartTime}}</template>
						</span>
						<span v-else>All Day Event</span>
					</div>
				</v-ons-list-item>
				<v-ons-list-item v-if="eventData.related_item">
					<div class="left icon"><v-ons-icon icon="fa-link" class="list-item__icon"></v-ons-icon></div>
					<div class="center">{{eventData.related_item.title}}</div>
				</v-ons-list-item>
				<v-ons-list-item v-if="eventData.attachment">
					<div class="left icon"><v-ons-icon icon="fa-file-pdf" class="list-item__icon"></v-ons-icon></div>
					<div class="center word-break" @click="openAttachment(eventData.attachment)">{{eventData.attachment.title}}</div>
				</v-ons-list-item>
				<v-ons-list-header>Description</v-ons-list-header>
				<v-ons-list-item v-if="eventData.description">
					<div v-html="eventData.description" v-if="eventData.description">
					</div>
				</v-ons-list-item>
			</v-ons-list>


		</div>
	</v-ons-page>
</template>

<script>

	import geocoding from '@/services/geocoding';
	import moment from 'moment';
	import SingleDocument from "./SingleDocument";

	export default {
		data() {
			return {
				eventData: {},
				onDate: "",
				mapData: {},
				hasCoordinates: false,
				infoWIndowContext: {},
				markersList: [
					{
						"title": "Faenza",
						"description": "Faenza is an Italian city and comune, in the province of Ravenna, Emilia-Romagna, situated 50 kilometres southeast of Bologna.",
						"position": {
							"lat": 34.731943,
							"lng": 135.731617
						}
					},
				],
				center: {
					lat: 34.734004,
					lng: 135.73660
				},
				path: [
					{
						lat: 34.731943,
						lng: 135.731617
					},
				]
			}
		},
		computed : {

		},
		mounted() {
			if(this.eventData.location){
				this.geoCodeAddress(this.eventData.location);
			}
		},
		methods: {
			openAttachment(attachment) {
				console.log(attachment);
				attachment.eventAttachment = true;
				this.$store.commit('navigator/push', {
					extends: SingleDocument,
					data() {
						return attachment;
					}
				});
			},
			geoCodeAddress(address) {
				let self = this;
				geocoding().get('json?address=' + address + '&key='+process.env.VUE_APP_GOOGLE_GEOCODING_KEY).then(function(resp){
					let response = resp.data;
					if (!(response.status === 'ZERO_RESULTS' || response.status === 'REQUEST_DENIED' || response.results === [])) {
						self.mapData.position = response.results[0].geometry.location;
						self.hasCoordinates = true;
					}else {
						console.log("Coordinates could not be located for this address")
					}
				}).catch(function(e){
					console.log(e);
				});
			},
			panToMarker (pos) {
				this.$refs.Map.panTo(pos)
			},
			setPanorama (pos) {
				this.$refs.Map.setStreetView(pos, {}, (err, data) => {
					console.log(err)
					console.log(data)
				})
			}
		},
		filters: {
			momentStartTime: function (date) {
				return moment(date).format('HH:mm');
			},
			truncatedStartTime: function (time) {
				if(time){
					return time.substring(0, 5);
				}else {
					return '';
				}

			},
			fullDateStartTime: function (date) {
				return moment(date).format('ddd, Do of MMM YYYY');
			},
		},
	}
</script>

<style>
	.qf-map-placeholder {
		width: 100%;
		display: block;
		position: relative;
	}

	img.map-placeholder {
		width: 100%;
		display: block;
		position: relative;
	}

	.qf-separator {
		width: 100%;
		height: 1px;
		background: #8e8e8e;
		position: relative;
		box-sizing: border-box;
		margin: 10px auto;
		display: block;
	}
</style>